
import React from 'react'
export const Card: React.FC<React.PropsWithChildren<{title?: string; className?: string}>> = ({ title, children, className }) => (
  <div className={`rounded-2xl shadow p-4 bg-white ${className||''}`}>
    {title && <h3 className="text-lg font-semibold mb-2">{title}</h3>}
    <div>{children}</div>
  </div>
)
